import axios from '../services/axios';


import { HINTS_URL, RESTAURANT_ID } from '../config/api';
import { setKioskCustomer } from '../reducers/kioskUserReducer';
import { uploadFinish, uploadStart } from '../reducers/uploadReducer';
import { hidePage } from '../reducers/pageReducer';
import { openModal, hideModal } from '../reducers/modalReducer';
import { useKioskUser, setUser, isUser } from "../reducers/userReducer";
import { getValidTokenKiosk, authHeader } from "../services/getValidToken";
import {
  isUnidentifiedCustomer,
  isPaymentKiosk,
  isStrictMedicalInventoryRestrictionEnabled
} from "../selectors/configSelectors";
import { addProduct, cartUpdated } from '../reducers/cartReducer'
import { resetHoldProduct } from '../reducers/holdProductReducer';
import { setDeliveryAddresses, setPickupAddresses, setDelivery, setPickup } from '../reducers/addressReducer';
import { startGetOrders } from '../actions/order';
import { isSuccessResultCode } from '../helpers/api';
import { rootPageUri, ordersUri } from '../config/uri';
import { shouldHandleOrdersAfterLogin } from '../selectors/paymentKioskSelectors';
import { setHandleOrdersAfterLogin } from '../reducers/paymentKioskReducer';
import { getPaymentKioskLoginMode } from '../services/paymentKiosk';
import { LOGIN_MODE } from '../const/paymentKiosk';
import { getOrders } from '../services/tickets';
import { reset } from "./product";
import { pushWithQueryParams } from '../services/uri';

export function signIn(signIn) {
  return axios.post(`${HINTS_URL}/HintsService/v1.0/rest/ecommerce/signin`, signIn);
}

export function signUp(signUp) {
  return axios.post(`${HINTS_URL}/HintsService/v1.0/rest/ecommerce/signup`, signUp);
}

export const useKioskCustomer = () => async (dispatch, getState) => {
  const state = getState();
  const user = state.kioskUser;
  getValidTokenKiosk();
  dispatch(useKioskUser(user));
  dispatch(hideModal());
};

export const signInTreezUser = (userName, password) => (dispatch, getState) => {
  dispatch(uploadStart());

  const openIncorrectUserOrPasswordModal = () => openModal({
    modalType: 'GENERIC',
    modalProps: {
      text: 'Username or password is incorrect',
      stay: true,
      afterClose: () => {
        dispatch(openModal({
          modalType: "KIOSK_LOGIN_FORM",
          modalProps: {
            unclosable: true
          }
        }));
      }
    }
  });

  const loginRequest = {
    restaurantId: RESTAURANT_ID,
    userName,
    password
  };

  return axios.post(
    `${HINTS_URL}/HintsService/v1.0/rest/portaluser/login/kiosk`,
    loginRequest
  )
    .then((result) => {
      dispatch(hidePage());
      dispatch(hideModal());

      if (isSuccessResultCode(result.data)) {
        const data = result.data;

        dispatch(setKioskCustomer(data));

        if (isUnidentifiedCustomer(getState())) {
          dispatch(useKioskCustomer());
        }
      } else {
        dispatch(openIncorrectUserOrPasswordModal());
      }

      return result;
    })
    .catch(() => {
      dispatch(hidePage());
      dispatch(hideModal());

      dispatch(openIncorrectUserOrPasswordModal());
    })
    .finally(() => {
      dispatch(uploadFinish());
    });
};

export const signInById = (driverLicenseId, driverLicenseState) => async (dispatch, getState) => {
  const openIncorrectIdScanModal = () => openModal({
    modalType: 'GENERIC',
    modalProps: {
      text: 'Error occurred when signing in with your ID',
      stay: true,
      afterClose: () => {
        dispatch(openModal({
          modalType: "LOGIN_FORM",
          modalProps: {
            raisedClass: 'raise payment-kiosk-login-form'
          }
        }));
      }
    }
  });

  dispatch(uploadStart());

  const signRequest = {
    driverLicenseId: driverLicenseId,
    state: driverLicenseState
  };

  const token = await getValidTokenKiosk();

  return axios
    .create()
    .post(
      `${HINTS_URL}/HintsService/v1.0/rest/ecommerce/signin/id`,
      signRequest,
      authHeader(token)
    )
    .then((signInResponse) => {
      dispatch(hideModal());

      if (isSuccessResultCode(signInResponse.data)) {
        let signInData = signInResponse.data;

        dispatch(postProcessSignIn(signInData));
      } else {
        dispatch(openIncorrectIdScanModal());
      }
    })
    .catch(() => {
      dispatch(hideModal());
      dispatch(openIncorrectIdScanModal());
    })
    .finally(() => {
      dispatch(uploadFinish());
    });
}

export const postProcessSignIn = (signInData) => async (dispatch, getState) => {
  const openLoginInfoModal = () => openModal({
    modalType: 'LOGIN_INFO_FORM',
    modalProps: {
      isSuccess: true
    }
  });

  const openItemAddedModal = () => openModal({
    modalType: "ITEM_ADDED_FORM",
    modalProps: {}
  });

  const openProductViewModal = (product, productIndex) => openModal({
    modalType: '1X_PRODUCT_VIEW',
    modalProps: {
      product: product,
      productIndex: productIndex,
    }
  });

  dispatch(setUser({
    firstName: signInData.firstName,
    lastName: signInData.lastName,
    isID: signInData.dl,
    isRec: signInData.rec,
    isMisc: signInData.misc,
    rewardPoints: signInData.rewardPoints,
    rewardTier: signInData.rewardTier,
    redemeedPoints: signInData.redemeedPoints,
    tokens: signInData.tokens,
    adult: signInData.adult,
    customerType: signInData.customerType,
    id: signInData.id,
    isFetched: true
  }));

  // close menu
  dispatch(hidePage());

  // map pickups
  const pickAddresses = signInData.pickupAddresses.map(addr => {
    return { dispensaryName: addr.name, address: addr }
  })

  // map delivery
  const deliveryAddresses = signInData.addresses.map(addr => {
    return { address: addr }
  })

  dispatch(setPickupAddresses(pickAddresses));
  dispatch(setDeliveryAddresses(deliveryAddresses));

  // set primary address type , primary address id
  if (signInData.deliveryDetail.addressId > -1) {
    if (signInData.deliveryDetail.type === 'PICKUP') {
      // find primary address index
      const addressIndex = signInData.pickupAddresses.findIndex(a => a.id === signInData.deliveryDetail.addressId);
      dispatch(setPickup(addressIndex));
    } else {
      // find primary address index
      const addressIndex = signInData.addresses.findIndex(a => a.id === signInData.deliveryDetail.addressId);
      dispatch(setDelivery(addressIndex));
    }
  }

  const state = getState();

  const paymentKioskloginMode = getPaymentKioskLoginMode();

  // get orders while logging in
  if (isUser(state)) {
    if (isPaymentKiosk(state)) {
      if (paymentKioskloginMode !== LOGIN_MODE.WITH_REDIRECT) {
        if (!shouldHandleOrdersAfterLogin(state)) {
          dispatch(startGetOrders());
        }
      }
    }
  }

  if (isStrictMedicalInventoryRestrictionEnabled(state)) {
    dispatch(reset(state))
  }

  let redirectionUri = null;

  // handle holded product
  if (state.holdProduct) {
    switch (state.holdProduct.type) {
      case 'cart':
        dispatch(addProduct(state.holdProduct.product));
        dispatch(cartUpdated());

        if (isPaymentKiosk(state)) {
          dispatch(openItemAddedModal());

          redirectionUri = rootPageUri;
        }
        else {
          dispatch(openLoginInfoModal());
        }
        break;

      case 'short':
        dispatch(openProductViewModal(
          state.holdProduct.product,
          state.holdProduct.index
        ));
        break;

      default:
        break;
    }

    dispatch(resetHoldProduct());
  }
  else {
    dispatch(openLoginInfoModal());

    if (isPaymentKiosk(state)) {
      if (paymentKioskloginMode === LOGIN_MODE.WITH_REDIRECT) {
        await getOrders(0).then(
          ordersResponse => {
            if (!!ordersResponse.data) {
              const customerOrders = ordersResponse.data.data;

              if (Array.isArray(customerOrders) && customerOrders.length === 1) {
                const orderId = customerOrders[0].orderId;
                const orderUri = ordersUri + '/' + orderId;

                redirectionUri = orderUri;
              }
            }
          },
          error => console.log(error)
        );
      }
      else if (shouldHandleOrdersAfterLogin(state)) {
        dispatch(setHandleOrdersAfterLogin(false));

        redirectionUri = ordersUri;
      }
    }
  }

  if (!!redirectionUri) {
    dispatch(pushWithQueryParams(redirectionUri));
  }
}



// WEBPACK FOOTER //
// ./src/actions/login.js